import React from 'react';

import type { TravelContent } from 'types/locationView';

const Summary: React.FC<{ travelContent: TravelContent }> = ({ travelContent }) => (
  <div
    className="sl-travel-summary"
    dangerouslySetInnerHTML={{ __html: travelContent.content.body }}
  />
);

export default Summary;
